"use strict";

const strf = require("./string.format.js");

/*
 *
 * Constants
 *
 */

class MetaStreamIOConstants {
  // MetaStreamIO constants
  get MetaStreamIO_ValueNotSet() {
    return "unassigned";
  }
  get MetaStreamIO_Unidentified() {
    return "unidentified";
  }
  get MetaStreamIO_SessionLengthSeconds() {
    return 1800;
  }
  get MetaStreamIO_SendOnceDefault() {
    return false;
  }

  get MetaStreamIO_Endpoint_User() {
    return "/user";
  }

  // Account
  get MetaStreamIO_AccountTypeSet() {
    return "account type set to  {0}";
  }
  get MetaStreamIO_AccountBalanceSet() {
    return "account balance for {0} set to {1}";
  }

  get MetaStreamIO_AccountTypeNotSet() {
    return "not set";
  }

  // AsyncStorage names
  get MetaStreamIO_Async_ReadSuccess() {
    return "AsyncStorage retrieval for {0} returned: {1}";
  }
  get MetaStreamIO_Async_ReadFail() {
    return "AsyncStorage retrieval for {0} failed";
  }
  get MetaStreamIO_Async_WriteSuccess() {
    return "AsyncStorage set {0} to {1}";
  }
  get MetaStreamIO_Async_WriteFail() {
    return "AsyncStorage attempt to set {0} failed.";
  }
  get MetaStreamIO_Async_Cart() {
    return "tracker_cart";
  }
  get MetaStreamIO_Async_CartId() {
    return "tracker_cart_id";
  }
  get MetaStreamIO_Async_EventParameters() {
    return "event_parameters";
  }
  get MetaStreamIO_Async_UserProperties() {
    return "user_properties";
  }
  get MetaStreamIO_Async_UserId() {
    return "user_id";
  }

  // Cart
  get MetaStreamIO_Cart_AddedToCart() {
    return "{0} added to cart";
  }
  get MetaStreamIO_Cart_Cart() {
    return "cart: {0}";
  }
  get MetaStreamIO_Cart_CartIdSet() {
    return "cart id set to {0}";
  }
  get MetaStreamIO_Cart_QuantityReduced() {
    return "{0} quantity reduced to {1}";
  }
  get MetaStreamIO_Cart_QuantityZero() {
    return "{0} quantity already zero";
  }
  get MetaStreamIO_Cart_BundleNotInCart() {
    return "{0} not found in cart, not removed";
  }
  get MetaStreamIO_Cart_RemoveAllItems() {
    return "all items removed from cart and new cart id assigned";
  }

  // Encryption suite
  get MetaStreamIO_Encryption_SHA256Generated() {
    return "sha256 hash generated: {0}";
  }
  get MetaStreamIO_Encryption_UUIDv4Generated() {
    return "new uuid generated: {0}";
  }

  // Environment
  get MetaStreamIO_Environment_AppInfo() {
    return "app info: {0}";
  }
  get MetaStreamIO_Environment_AppPerformance() {
    return "app performance: {0}";
  }
  get MetaStreamIO_Environment_Device() {
    return "device: {0}";
  }
  get MetaStreamIO_Environment_Network() {
    return "network: {0}";
  }

  // Events and user properties logs
  get MetaStreamIO_Log_EventTracked() {
    return "event tracked: {0}";
  }
  get MetaStreamIO_Log_EventTrackFailed() {
    return "event track failed: {0}";
  }
  get MetaStreamIO_Log_EventParameters() {
    return "event parameters: ";
  }
  get MetaStreamIO_Log_EventParameterSet() {
    return "event parameter {0} set to {1}  with type {2}";
  }
  get MetaStreamIO_Log_SendOnce() {
    return "send once enabled: event parameters cleared";
  }
  get MetaStreamIO_Log_RequestObject() {
    return "request object >>";
  }
  get MetaStreamIO_Log_UserIdSet() {
    return "user id set: {0}";
  }
  get MetaStreamIO_Log_CIAMIdSet() {
    return "ciam id set: {0}";
  }
  get MetaStreamIO_Log_EmailIdSet() {
    return "email id set: {0}";
  }
  get MetaStreamIO_Log_UserCountrySet() {
    return "user country set: {0}";
  }
  get MetaStreamIO_Log_UserPropertySet() {
    return "user property {0} set to {1}  with type {2}";
  }
  get MetaStreamIO_Log_PushDeviceTokenSet() {
    return "device token set: {0}";
  }

  // Event names
  get MetaStreamIO_EventName_Purchase() {
    return "purchase";
  }
  get MetaStreamIO_EventName_SendAirtime() {
    return "send_airtime";
  }
  get MetaStreamIO_EventName_QuickBuy() {
    return "quick_buy";
  }

  // Logger
  get MetaStreamIO_Logger_Prefix() {
    return "[MetaStreamIO]";
  }
  get MetaStreamIO_Logger_MessageFormat() {
    return "{0} {1} {2}";
  }
  get MetaStreamIO_Logger_Category_Success() {
    return "success";
  }
  get MetaStreamIO_Logger_Category_Environment() {
    return "environment";
  }

  // MetaStreamIO
  get MetaStreamIO_IO_ProjectEnvironmentSet() {
    return "project environment set to {0}";
  }
  get MetaStreamIO_IO_ProjectEnvironmentNotSet() {
    return "project environment not set";
  }
  get MetaStreamIO_IO_ProjectIdSet() {
    return "project id set to {0}";
  }
  get MetaStreamIO_IO_ProjectIdNotSet() {
    return "no project id specified";
  }

  // Network
  get MetaStreamIO_Network_GetDataIssue() {
    return "getData issue: {0} [endpoint: {1}]";
  }
  get MetaStreamIO_Network_GetDataReturn() {
    return "getData returned: {0}";
  }
  get MetaStreamIO_Network_PostDataIssue() {
    return "postData issue: {0} [endpoint: {1}]";
  }
  get MetaStreamIO_Network_PostDataReturn() {
    return "postData returned: {0}";
  }
  get MetaStreamIO_Network_SilentMode() {
    return "silent mode enabled; no data sent";
  }
  get MetaStreamIO_Network_SilentModeEnabled() {
    return "silent mode enabled";
  }
  get MetaStreamIO_Network_EndpointSet() {
    return "endpoint set: {0}";
  }
  get MetaStreamIO_Network_EndpointTestFailed() {
    return "endpoint test failed: {0}";
  }

  // Session
  get MetaStreamIO_User_Guest() {
    return "unidentified:guest";
  }
  get MetaStreamIO_Session_SourceNotSet() {
    return "not set";
  }
  get MetaStreamIO_Session_SessionIdSet() {
    return "session id generated: {0}";
  }
  get MetaStreamIO_Session_SessionStillValid() {
    return "session still valid - check passed";
  }
  get MetaStreamIO_User_HashModeDefault() {
    return true;
  }
  get MetaStreamIO_User_DoubleHashModeDefault() {
    return false;
  }
  get MetaStreamIO_User_Base64Default() {
    return false;
  }
  get MetaStreamIO_User_SecureEncryptionDefault() {
    return false;
  }

  // Utility
  get MetaStreamIO_Utility_ComparedArraysAreDifferent() {
    return "evaluated arrays are different";
  }
  get MetaStreamIO_Utility_ComparedArraysAreIdentical() {
    return "evaluated arrays are identical";
  }
}

module.exports = MetaStreamIOConstants;
